import { render, staticRenderFns } from "./QuotationStepCostsViewer.vue?vue&type=template&id=3c96ecde"
import script from "./QuotationStepCostsViewer.vue?vue&type=script&lang=js"
export * from "./QuotationStepCostsViewer.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepCostsViewer.vue?vue&type=style&index=0&id=3c96ecde&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports